import { userConstants } from "../constants/user.constants";

export function users(state = {creating: false}, action) {

  switch (action.type) {
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        error: action.error,
      }
    case userConstants.USER_GETLIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case userConstants.USER_GETLIST_SUCCESS:
      return {
        ...state,
        list: action.list,
        isLoading: false,
      };
    case userConstants.USER_GETLIST_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
      case userConstants.USER_GET_DETAIL_REQUEST:
        return {
          ...state,
          isLoading: true,
        };
      case userConstants.USER_GET_DETAIL_SUCCESS:
        return {
          ...state,
          user_detail: action.user,
          isLoading: false,
        };
      case userConstants.USER_GET_DETAIL_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false,
        };      
    case userConstants.USER_CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case userConstants.USER_CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
      };
    case userConstants.USER_CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        creating: false,
      };
      case userConstants.USER_EDIT_REQUEST:
        return {
          ...state,
          isLoading: true,
          editRequest: 'started',
        };
      case userConstants.USER_EDIT_SUCCESS:
        return {
          ...state,
          isLoading: false,
          editRequest: 'completed'
        };
      case userConstants.USER_EDIT_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false,
          editRequest: 'error',
        };      
      case userConstants.USER_GET_ALL_ROLES_REQUEST:
        return {
          ...state,
          isLoading: true,
        };
      case userConstants.USER_GET_ALL_ROLES_SUCCESS:
        return {
          ...state,
          roles: action.list,
          isLoading: false,
        };
      case userConstants.USER_GET_ALL_ROLES_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false,
        };            
    case userConstants.USER_PWD_RESET_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case userConstants.USER_PWD_RESET_SUCCESS:
      return {
        ...state,
        creating: false,
      };
    case userConstants.USER_PWD_RESET_FAILURE:
      return {
        ...state,
        error: action.error,
        creating: false,
      };
    default:
      return state;
  }
}
